import type { TagName } from '#dn-types/host.ts';
import { useOverrideMaps } from '../../hooks/useOverrideMaps.ts';

/**
 * Given a list of tag names, return a mapping between override keys and the override values set by those tags, with the
 * highest priority tags winning out.
 */
export function useTagOverrideMap(tagNames: TagName[]) {
  const { configMap, statsMap } = useOverrideMaps({
    hostConfigOverrides: [], // We only want tag sources
    tagNames: tagNames,
  });
  // Merge config and stats maps
  return new Map(
    (function* () {
      yield* configMap;
      yield* statsMap;
    })()
  );
}
